const BaseMap = {
    STANDARD: 'se_basemap',
    STREET: 'mapbox_street_map',
    SATELLITE: 'satellite',
};

export const BASE_MAP_THUMBNAIL = {
    [BaseMap.STANDARD]: 'basemap-standard.png',
    [BaseMap.STREET]: 'basemap-street.png',
    [BaseMap.SATELLITE]: 'basemap-satellite.png',
};

export default BaseMap;
